import React, { useState } from 'react';
import Footer from '../components/Footer';

const ContactUs = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSendEmail = () => {
    const mailtoLink = `mailto:imperierholdings@gmail.com?subject=Contact from ${encodeURIComponent(name)}&body=${encodeURIComponent(message)}%0A%0AFrom: ${encodeURIComponent(email)}`;
    window.location.href = mailtoLink;
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl font-bold text-black mb-12 text-center opacity-0 animate-fade-in-up">CONTACT US</h1>

          {/* Contact Form */}
          <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-lg shadow-xl border border-grey opacity-0 animate-fade-in-up delay-200">
            <h2 className="text-3xl font-bold mb-8 text-black">
              Send us a Message
            </h2>

            <div className="space-y-6">
              <div>
                <label className="text-sm font-medium text-black block mb-2">
                  Name
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full p-3 border-2 border-grey rounded-md focus:outline-none focus:border-lightBlue bg-white text-black"
                  placeholder="Enter your name"
                />
              </div>

              <div>
                <label className="text-sm font-medium text-black block mb-2">
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full p-3 border-2 border-grey rounded-md focus:outline-none focus:border-lightBlue bg-white text-black"
                  placeholder="Enter your email"
                />
              </div>

              <div>
                <label className="text-sm font-medium text-black block mb-2">
                  Message
                </label>
                <textarea
                  rows="6"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="w-full p-3 border-2 border-grey rounded-md focus:outline-none focus:border-lightBlue bg-white text-black"
                  placeholder="Your message..."
                ></textarea>
              </div>

              <button
                onClick={name && email && message ? handleSendEmail : null}
                disabled={!name || !email || !message}
                className="bg-black text-white px-8 py-3 rounded-md font-semibold hover:bg-darkBlue transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Send Message
              </button>
            </div>
          </div>

          {/* Contact Information */}
          <div className="max-w-4xl mx-auto mt-12 text-center">
            <h3 className="text-2xl font-bold text-black mb-6">Or reach us directly at:</h3>
            <div className="space-y-3">
              <p className="text-lg text-gray-700">
                <a href="mailto:imperierholdings@gmail.com" className="hover:text-lightBlue transition-colors duration-200">
                  imperierholdings@gmail.com
                </a>
              </p>
              <p className="text-lg text-gray-700">
                <a href="mailto:yash.imperier@gmail.com" className="hover:text-lightBlue transition-colors duration-200">
                  yash.imperier@gmail.com
                </a>
              </p>
              <p className="text-lg text-gray-700">
                <a href="tel:+918840594334" className="hover:text-lightBlue transition-colors duration-200">
                  +91 88405 94334
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;

